/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_InactiveInputs */

const vi_warehouse_position_inactive = /** @type {(inputs: Warehouse_Position_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng dùng`)
};

/**

* @param {Warehouse_Position_InactiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_inactive = /** @type {((inputs?: Warehouse_Position_InactiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_InactiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_inactive(inputs)
});